// extracted by mini-css-extract-plugin
export var active = "_2e-7";
export var backButton = "_2e-6";
export var clone = "_2e-c";
export var collapseBar = "_2e-h";
export var collapseMode = "_2e-j";
export var collapsed = "_2e-l";
export var dragHandle = "_2e-a";
export var dropdownIcon = "_2e-e";
export var expanding = "_2e-k";
export var hidden = "_2e-r";
export var iconContainer = "_2e-o";
export var iconSwapper = "_2e-q";
export var navItem = "_2e-4";
export var navItemIcon = "_2e-d";
export var navProfile = "_2e-5";
export var notificationCountBadge = "_2e-g";
export var notificationDot = "_2e-p";
export var optionsContainer = "_2e-f";
export var primaryNav = "_2e-0";
export var primaryTab = "_2e-m";
export var secondaryNav = "_2e-1";
export var selected = "_2e-n";
export var settingsNav = "_2e-2";
export var settingsNavItems = "_2e-3";
export var show = "_2e-b";
export var sideNav = "_2e-i";
export var teamItem = "_2e-8";
export var userProfileItem = "_2e-9";